import { ICultureVariation } from 'app/containers/Cultures/slice/types';
import { IFieldProgress } from 'app/containers/Task/slice/types';
import { LatLngExpression, LatLngTuple } from 'leaflet';

/* --- STATE --- */
export interface MapState {
  isMapReady: boolean;
  loading: boolean;
  polygons: IPolygon[];
  fieldsCultureVariations: IFieldsCultureVariations;
  activePolygonId: number | null;
  singleFieldOnMap: {
    fieldId: null | number;
  };
  uploadFields: {
    tempPolygons: ITempPolygon[];
    selectedIds: string[];
  };
  layers: ILayer[];

  mapMode: MapModeEnum;
  selectedPolygons: number[];
  cultureMenuSelectedIds: number[];
  cultureMenuSelectedVariationsIds: number[];
  fitCoordArrOnMap: LatLngTuple[] | L.LatLng[] | null;
  fieldsProgress: {
    fieldsProgressArr: IFieldProgress[] | null;
    updatedFieldsArr: IFieldProgress[] | null;
  };

  transport: {
    hiddenOnMapGpsVehicleIds: number[];
    highlightedRoutesGpsVehicleId: number | null;
  };

  showCurrentUserLocation: boolean;

  visibleRoutesBySelectedTaskFieldSeasonId: number | null;
}

export type MapMenuType =
  | 'CULTURE'
  | 'LAYER'
  | 'TRANSPORT'
  | 'FIELD_SELECT_BY_CULTURE'
  | null;
export interface IFieldsCultureVariations {
  [key: string]: ICultureVariation[];
}

export enum MapModeEnum {
  view = 'view',
  draw = 'draw',
  progress = 'progress',
  upload = 'upload',
  singleField = 'singleField',
  taskFields = 'taskFields',
  culture = 'culture',
  createPolygon = 'createPolygon',
  editPolygon = 'editPolygon',
  runsWithoutTask = 'runsWithoutTask',
  taskRoutes = 'taskRoutes',
  fieldsAndRoutes = 'fieldsAndRoutes',
}

export type FieldsBoundaries = LatLngTuple[][][];

export interface IFieldParameters {
  cultureVariationsArr: ICultureVariation[];
  fieldId: number;
  fieldId2: number;
  name: string;
  cultureId: number | null;
  cultureName: string | null;
  cultureColor: string | null;
  companyId: number;
  companyName: string;
  area: string;
  areaNum: number;
  seasonId?: number;
}

export interface IPolygon {
  id: string;
  coordinates: FieldsBoundaries;
  weight: number;
  markerPosition: LatLngTuple;
  layerId: string;
  fieldParameters: IFieldParameters;
}

export interface IMappedField extends IPolygon {
  fieldProgressUpdate?: number;
  isSelected: boolean;
}

export interface ITempPolygon {
  type: string;
  propertiesJson: string;
  id: string;
  coordinates: FieldsBoundaries;
  weight: number;
  markerPosition: LatLngTuple;
  layerId: string;
}

export interface IMappedTempField extends ITempPolygon {
  isSelected: boolean;
}

export interface ILayer {
  id: string;
  name: string;
  visible: boolean;
  layers?: string;
  layerType: 'wmsTile' | 'polygon';
  opacity: number;
}

export interface IFieldFeature {
  type: string;
  id: string;
  geometry: {
    type: string;
    coordinates: FieldsBoundaries;
  };
  geometry_name: string;
  properties: {
    id: number;
    season_id: number;
    field_id: number;
    field_geometry_id: string;
    company_id: number;
    company_name: string;
    field_name: string;
    culture_name: string | null;
    culture_color: string | null;
    culture_id: number | null;
    area: number;
  };
}
export interface IFieldsResponse {
  type: string;
  features: IFieldFeature[];
  totalFeatures: number;
  numberMatched: number;
  numberReturned: number;
  timeStamp: string;
  crs: {
    type: string;
    properties: {
      name: string;
    };
  };
}

export interface IFieldsByCompanies {
  companyId: number;
  companyName: string;
  fieldSeasonIds: number[];
  areaNum: number;
  area: string;
  fieldParams: IFieldParameters[];
}

export interface IProgressModalState {
  visible: boolean;
  field?: IMappedField;
}

export interface ILoadPolygonsPayload {
  envId: number;
  seasonId: number;
  companyId: number | null;
  companyGroupId: number | null;
}

export interface IMapCulture {
  cultureName: string | null;
  cultureId: number;
  cultureColor: string | null;
  isSelected: boolean;
  area: string;
  areaNum: number;
  cultureVariations: {
    isSelected: boolean;
    cultureVariation: ICultureVariation;
    areaNum: number;
    area: string;
  }[];
}

export type TransportFeatureData = {
  type: string;
  // its invalid id - dont use it for anything
  id: unknown;
  geometry: { type: string; coordinates: LatLngTuple };
  geometry_name: string;
  properties: {
    color: string;
    gps_vehicle_id: number;
    gps_id: number;
    company_id: number | null;
    license_plate: string;
    altitude: number;
    speed: number;
    course: number;
    satellites_count: number;
    ignition_on: null | boolean;
    datetime: string;

    model: string | null;
    first_name: string | null;
    last_name: string | null;
    phone_number: string | null;
    implement_model: string | null;
    fuel_level: number | null;
  };
};

export interface ITransportPositionResponse {
  type: string;
  features: TransportFeatureData[];
  totalFeatures: number;
  numberMatched: number;
  numberReturned: number;
  timeStamp: string;
  crs: { type: string; properties: { name: string } };
}

export type MapBoundsForLocationState = {
  southWest: LatLngExpression;
  northEast: LatLngExpression;
};

export type LocationStateWithMapBounds =
  | {
      mapBounds?: MapBoundsForLocationState;
    }
  | undefined;
